import { List, Skeleton } from '@atom/mui';

import { THREADS_PER_PAGE } from './hooks/useThreads';

export type ChatThreadsLoadingProps = {
  loading: boolean;
  numThreads?: number;
};

const ChatThreadsLoading = ({
  loading,
  numThreads = THREADS_PER_PAGE,
}: ChatThreadsLoadingProps) => {
  if (!loading) {
    return null;
  }

  return (
    <>
      {new Array(numThreads).fill(null).map((_, index) => {
        return (
          <List.ListItemButton key={index} style={{ width: '100%' }}>
            <Skeleton width="100%" />
          </List.ListItemButton>
        );
      })}
    </>
  );
};

export default ChatThreadsLoading;
